import { MeetingSessionOvenMediaReceiverManagerBaseData } from "@kalyzee/kast-web-sdk";
import { OvenMediaReceiverWebRTCSession } from "@kalyzee/kast-web-sdk/webrtc";
import { MeetingSession, MeetingSessionMedia } from "@kalyzee/kast-web-sdk/websocket";

export interface MeetingPlayerRenderingContext {
    isPlayingSound: boolean;
}

// Can be used to wrap the player in some interfaces, given a context
export type PlayerContainerRenderer = (
    children: React.ReactNode, 
    context?: MeetingPlayerRenderingContext,
) => React.ReactNode;

export interface PlayerRendererProviderOptions {
    muted?: boolean;
    hideSoundEffect?: boolean;
}

// The root player renderer, optionally taking a container renderer to wrap its result
export type PlayerRendererProvider = (
    containerRenderer?: PlayerContainerRenderer,
    options?: PlayerRendererProviderOptions,
) => React.ReactNode;

export type PlayerItemData = 
  | { type: 'meeting_session', meetingSession: MeetingSession, videoSessions: OvenMediaReceiverWebRTCSession<MeetingSessionOvenMediaReceiverManagerBaseData>[], online?: boolean }
  | { type: 'video_session', videoSession: OvenMediaReceiverWebRTCSession<MeetingSessionOvenMediaReceiverManagerBaseData> }
  | { type: 'stream', mediaStream: MediaStream, poster?: string } ;

export type ExtraPlayerItemData = {
    extra?: {
        meetingSession?: MeetingSession;
        mediaSession?: MeetingSessionMedia;
        isLeaderSession?: boolean;
    },
};

export class PlayerItem {
    constructor(private data: PlayerItemData & ExtraPlayerItemData) {}
    public getId(): string {
        switch (this.data.type) {
            case 'meeting_session':
                return `meeting_session_${this.data.meetingSession.id}`;
            case 'video_session':
                return `video_session_${this.data.videoSession.data.mediaSession.id}`;
            case 'stream':
                return `stream_${this.data.mediaStream.id}`;
        }
    }
    public getData(): PlayerItemData & ExtraPlayerItemData {
        return this.data;
    }
}
